import React from 'react';

const finance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enableBackground="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m512 481.897h-31v-30h-450v30h-31v30h512z"/><path d="m31 150.897h450v60h-450z"/><path d="m61 240.897h90v181h-90z"/><path d="m211 240.897h90v181h-90z"/><path d="m361 240.897h90v181h-90z"/><path d="m512 95.453-256-95.35-256 95.35v25.444h512zm-241-4.556h-30v-30h30z"/></g></svg>
  );
}

export default finance;
